// ── Toaster — короткие сообщения внизу экрана вместо системного alert() ──────
// alert() останавливает всё приложение, выглядит чужим и не переводится темой.
// notify() показывает сообщение над нижней панелью и мини-плеером, оно само
// исчезает через несколько секунд (ошибки — дольше), его можно закрыть.
//   notify(t("Импортировано 12 карточек"), { tone: 'success' });
//   notify(t("Ошибка загрузки: …"), { tone: 'error' });
// <Toaster/> один на всё приложение (App).

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Icon from '../Icon';
import { SANS } from '../themes';
import { t } from '../i18n';
import IconButton from './IconButton';
import { usePalette, Z } from './theme';
import { floatSurface } from './surface';

const listeners = new Set();
let seq = 0;

export function notify(text, { tone = 'info', ms } = {}) {
  const item = { id: ++seq, text: String(text), tone, ms: ms ?? (tone === 'error' ? 9000 : 5000) };
  listeners.forEach((l) => l(item));
}

const ICON = { info: 'alert', success: 'check', error: 'alert' };

export default function Toaster() {
  const C = usePalette();
  const [items, setItems] = useState([]);
  useEffect(() => {
    const timers = new Set();
    const on = (it) => {
      setItems((l) => [...l.slice(-2), it]); // не больше трёх сразу
      const timer = setTimeout(() => { timers.delete(timer); setItems((l) => l.filter((x) => x.id !== it.id)); }, it.ms);
      timers.add(timer);
    };
    listeners.add(on);
    return () => { listeners.delete(on); timers.forEach(clearTimeout); };
  }, []);
  if (!items.length) return null;
  const color = (tone) => (tone === 'error' ? C.danger : tone === 'success' ? C.green : C.blueDark);
  // data-layout-layer: сообщение временно лежит поверх страницы (само уйдёт или закроют) —
  // автопроверка не считает, что оно «закрывает» то, что под ним.
  return createPortal(
    <div role="status" aria-live="polite" data-layout-layer
      style={{ position: 'fixed', zIndex: Z.toast, left: 0, right: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8,
        bottom: 'calc(16px + var(--ac-nav-h, 0px) + var(--ac-mini-h, 0px) + env(safe-area-inset-bottom, 0px))', padding: '0 12px', pointerEvents: 'none' }}>
      {items.map((it) => (
        <div key={it.id} style={{ pointerEvents: 'auto', display: 'flex', alignItems: 'center', gap: 10, maxWidth: 520, width: '100%', boxSizing: 'border-box',
          padding: '6px 6px 6px 14px', ...floatSurface(C), color: C.text, border: `${C.borderW||1}px solid ${C.border}`, borderLeft: `4px solid ${color(it.tone)}`,
          borderRadius: 12, boxShadow: `0 12px 32px -12px ${C.shadowMd}`, fontFamily: SANS, fontSize: 14, lineHeight: 1.4 }}>
          <span style={{ color: color(it.tone), display: 'inline-flex', flexShrink: 0 }}><Icon n={ICON[it.tone] || 'alert'} s={18} /></span>
          <span style={{ flex: 1, minWidth: 0, overflowWrap: 'anywhere', padding: '6px 0' }}>{it.text}</span>
          <IconButton icon="close" label={t("Закрыть")} variant="ghost" size={36} onClick={() => setItems((l) => l.filter((x) => x.id !== it.id))} />
        </div>
      ))}
    </div>,
    document.body
  );
}
